import * as React from 'react';

export const useDuplicateControls = () => {
  const [showDuplicatesOf, setShowDuplicatesOf] = React.useState<string | null>(
    null
  );

  const handleShowDuplicatesOf = React.useCallback((fileName: string | null) => {
    setShowDuplicatesOf(fileName);
  }, []);

  const clearDuplicatesFilter = React.useCallback(() => {
    setShowDuplicatesOf(null);
  }, []);

  return {
    showDuplicatesOf,
    onShowDuplicatesOf: handleShowDuplicatesOf,
    clearDuplicatesFilter,
  };
};

